import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_NULL_WSPOSITIONS } from "./actionTypes";
import { getNullWsPositionsSuccess, getNullWsPositionsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* getNullWsPositions({ payload: { user } }) {
  try {
    const response = yield call(workstationAPI.getNullWSPositions, user.token);
   
    yield put(getNullWsPositionsSuccess(response.Positions, response.message));
  } catch (error) {
    yield put(getNullWsPositionsError(error));
  }
}

export function* watchGetNullWsPositions() {
  yield takeEvery(GET_NULL_WSPOSITIONS, getNullWsPositions);
}

function* getNullWsPositionsSaga() {
  yield all([fork(watchGetNullWsPositions)]);
}

export default getNullWsPositionsSaga;
